/**
 * Function de validation des commandes
 * @param  {object} values values du formulaire
 */
const validate = values => {
  const errors = {
    item: {}
  };
  if (!values.name) {
    errors.name = 'Champ requis';
  }

  if (values.insuranceRequired) {
    if (!values.value) errors.value = "Valeur de l'objet requise";
  }
  return errors;
};

export default validate;
